import {
    Component,
    HostBinding,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { IconComponent } from "../../components/icon/icon.component";

export type ValidationMessageType = "error_serious" | "error" | "warning" | "info" | "refresh";

@Component({
    selector: "rask-validation-message-row",
    templateUrl: "./validation-message-row.component.html",
    styleUrls: ["./validation-message-row.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IconComponent]
})
export class ValidationMessageRowComponent implements OnInit {

    @Input() message;
    @Input() type: ValidationMessageType;
    @HostBinding("class.warning") warning = false;
    @HostBinding("class.error") error = false;
    @HostBinding("class.info") info = false;

    icon: string;

    ngOnInit(): void {
        switch (this.type) {
            case "info":
                this.info = true;
                this.icon = "fal fa-info-circle";
                break;
            case "refresh":
                this.info = true;
                this.icon = "fal fa-sync";
                break;
            case "warning":
                this.warning = true;
                this.icon = "fal fa-exclamation-square";
                break;
            case "error":
                this.error = true;
                this.icon = "fal fa-exclamation-circle";
                break;
            case "error_serious":
                this.error = true;
                this.icon = "fal fa-exclamation-triangle";
                break;
        }
    }

}
